import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import { Form } from "semantic-ui-react";

import API from "../../../services/Api";
import useAuth from "../../login/AuthContext";

export const PushTest: React.FunctionComponent = () => {
  const { getAuthToken } = useAuth();
  const [userId, setUserId] = useState<string | null>(null);

  return (
    <Form>
      <Form.Field>
        <label>User Id</label>
        <Form.Input
          type="number"
          placeholder="User Id"
          onChange={(event, data) => {
            setUserId(data.value);
          }}
        />
      </Form.Field>
      <Button onClick={async () => API.sendPush(userId, "push", await getAuthToken())}>Send</Button>
    </Form>
  );
};
